export const tasksProgress = [
    {text: 'Complete physic video', percentage: '20%', color: 'aqua'},
    {text: 'Take Biology test', percentage: null, color: null},
    {text: 'Some task I need to do', percentage: '60%', color: 'red'},
    {text: 'Make beautiful transitions', percentage: '80%', color: 'yellow'}
];


// WEBPACK FOOTER //
// ./src/data/tasksProgress.js